const StepEnum = {
    ALERTS: 'ALERTS',
    ORCIDS: 'ORCIDS',
    PROFILE: 'PROFILE',
} as const;

export default StepEnum;
